module.exports = __webpack_public_path__ + "img/banner@2x.d20891d0.png";